import { render, staticRenderFns } from "./CustomTextArea.vue?vue&type=template&id=686cf747&"
import script from "./CustomTextArea.vue?vue&type=script&lang=js&"
export * from "./CustomTextArea.vue?vue&type=script&lang=js&"
import style0 from "./CustomTextArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports